<template>
    <div class="work_code_wrap">
        <!-- 코드 설정된 데이터 -->
        <div class="work_code_group" v-if="!isCustomized && !isBasic">
            <span class="work_code" :style="backgroundStyle">
                {{ getCodeName }}
            </span>
            <div class="work_group_memeber_name">
                <span>{{ getMembersNames }}</span>
            </div>
        </div>
        <!-- 시간 직접 설정된 데이터 -->
        <div class="work_code_group" v-if="isCustomized && !isBasic">
            <span class="work_code"
                  style="background-color: white; border: 1px solid var(--gray80); color:var(--gray100);">
                {{ getCustomTimeInfo }}
            </span>
            <div class="work_group_member_name">
                <span>{{ getMembersNames }}</span>
            </div>
        </div>
        <!-- 기본 근무 데이터 -->
        <div class="work_code_group dashed_top" v-if="!isCustomized && isBasic">
            <div class="work_group_member_name">
                <span>{{ getMembersNames }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from '@/util/MPMoment'
import { sheetState } from '../../../../../sheet-state'

export default {
    props: {
        value: Array,
        workCodes: Array
    },
    data() {
        return {
            sheetState,
        }
    },
    watch: {},
    computed: {
        isCustomized: function () {
            return this.value[0]?.isCustomized ?? false
        },
        isBasic: function () {
            return this.value[0]?.isBasic ?? false
        },
        setting: function () {
            return this.sheetState.reservationSetting
        },
        palette: function () {
            return this.setting?.workCodeColorPaletteID?.basicPalette ?? []
        },
        getCustomTimeInfo: function () {
            let start = moment(this.value[0]?.startedAt)
            let end = moment(this.value[0]?.endedAt)
            return `${ start.format('HH:mm') }~${ end.format('HH:mm') }`
        },
        getCodeName: function () {
            return this.value[0]?.workCodeID?.title ?? ''
        },
        getMembersNames: function () {
            let names = ''
            this.value.forEach((data, index) => {
                names += data.employee.title
                names += (this.value.length - 1) != index ? ', ' : ''
            })
            return names
        },
        currentWorkCode: function () {
            return this.workCodes.find(c => c._id == this.value[0]?.workCodeID?._id)
        },
        backgroundStyle: function () {
            let bgColorString = this.currentWorkCode?.usingCustomColor == true ? this.currentWorkCode?.customColorCode : this.palette?.[this.currentWorkCode?.paletteIndex]
            if (!bgColorString) return ''
            let hex = '#222222'

            let r = parseInt(bgColorString.substr(1, 2), 16)
            let g = parseInt(bgColorString.substr(3, 2), 16)
            let b = parseInt(bgColorString.substr(5, 2), 16)

            let l = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);

            if (l <= 150) {
                hex = '#FFFFFF'
            }
            return 'background-color:' + bgColorString + '; color:' + hex + ';'
        }
    }
}

</script>